import requestUrl from '@/api/requestUrl'
import { loading, isIE } from '@/utils'

function jsonToUrlParam(json) {
    return new URLSearchParams(json).toString()
}
/**
 * @description 下载文件
 * @param {string} url 文件链接地址
 **/
function downloadFile(url) {
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.click()
    // 释放内存，释放blob对象
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    link = null
}

/**
 * @description 下载文件
 * @param {blob} file 文件流
 * @param {string} filename
 **/
function downloadBlobFile(file, filename) {
    let blob = new Blob([file])
    if (isIE()) {
        navigator.msSaveBlob(blob, filename)
    } else {
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    }
}
/**
 * @description 下载文件
 * @param {function}api 文件流
 * @param {object}params 参数
 **/

export async function downloadFileByUrl(api, params) {
    let service = loading()
    try {
        service.download()
        const res = await api(params)
        if (/application\/json/.test(res.data.type)) {
            let reader = new FileReader()
            reader.onload = (e) => {
                if (e.target.readyState === 2) {
                    let resJson = {}
                    resJson = JSON.parse(e.target.result)
                    this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                }
            }
            reader.readAsText(res.data)
        }
        if (/application\/octet-stream/.test(res.data.type)) {
            const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
            downloadBlobFile(res.data, filename)
        }
    } catch (e) {
    } finally {
        service.close()
    }
}

//  1）100M以下默认转圈1s
// 2）100M≈4s，200M≈8s，以此类推
function renderLoading(size) {
    let loadingTime = size ? (size / 1024 / 1024 / 100) * 15 : 2
    if (loadingTime < 1) {
        loadingTime = 2
    }

    const _loading = loading()
    _loading.load()
    setTimeout(() => {
        _loading.close()
    }, loadingTime * 1000)
}

/**
 *
 * @param {*} params
 * 单个下载的请求参数
 */
export const downloadSingleFile = (params) => {
    params.siteClassification = sessionStorage.getItem('siteClassification')
    params.userId = localStorage.getItem('UID')
    let urlParams = jsonToUrlParam(params)

    // downloadFile(requestUrl(`/file/free/downloadGet?${urlParams}`))
    window.open(requestUrl(`/file/free/downloadGet?${urlParams}`), '_blank')
}

/**
 *@param {string} api 文件批量下载地址
 * @param {*} params 批量下载的请求参数
 * @param {number}size 批量下载文件的大小
 */

export const downloadBatchFiles = (api, params, size) => {
    params.siteClassification = sessionStorage.getItem('siteClassification')
    params.userId = localStorage.getItem('UID')
    let urlParams = jsonToUrlParam(params)

    downloadFile(requestUrl(`${api}?${urlParams}`))
    renderLoading(size)
}
